import { Box, Typography, Switch, Chip, Stack } from "@mui/material";
import { CheckBoxRounded, NotificationsActive, NotificationsOff } from "@mui/icons-material";
import { Reminder } from "../../../../../../organization-reminder/interfaces/IRemiders";
import { colors } from "../../../../../../ui/colors";

interface Props {
  reminder: Reminder;
  onToggle: (uid: string, isActive: boolean) => void;
  isSelected: boolean;
}

export default function ReminderRowTrue({ reminder, onToggle, isSelected }: Props) {
  return (
    <Box
      onClick={() => onToggle(reminder.uid, !isSelected)}
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 2,
        py: 1,
        px: 1.5,
        borderRadius: "8px",
        cursor: "pointer",
        transition: "0.15s",
        background: isSelected ? colors.orange[50] : "transparent",
        border: isSelected ? `1px solid ${colors.orange[200]}` : "1px solid transparent",
        "&:hover": { background: colors.orange[50] },
      }}
    >
      <Box sx={{ color: reminder.isActive ? colors.orange.base : colors.gray[300], display: "flex" }}>
        {reminder.isActive ? <NotificationsActive sx={{ fontSize: 16 }} /> : <NotificationsOff sx={{ fontSize: 16 }} />}
      </Box>

      <Typography sx={{ fontSize: 13, fontWeight: 600, color: colors.gray[800], flex: 1 }}>{reminder.name}</Typography>

      <Stack direction="row" gap={0.5}>
        {reminder.sendSms && <ChannelChip label="SMS" active={reminder.isActive} />}
        {reminder.sendEmail && <ChannelChip label="EMAIL" active={reminder.isActive} />}
      </Stack>

      <CheckBoxRounded
        sx={{
          color: isSelected ? colors.orange.base : colors.gray[300],
          fontSize: 24,
          transition: "0.2s",
          transform: isSelected ? "scale(1.1)" : "scale(1)",
        }}
      />
    </Box>
  );
}

const ChannelChip = ({ label, active }: { label: string; active: boolean }) => (
  <Chip
    label={label}
    size="small"
    sx={{
      height: 20,
      fontSize: 10,
      fontWeight: 800,
      borderRadius: "5px",
      backgroundColor: active ? colors.orange[100] : colors.gray[100],
      color: active ? colors.orange[700] : colors.gray[400],
      "& .MuiChip-label": { px: 1 },
    }}
  />
);
